// In-memory demo data for the Store Ops Console.
// Stands in for the real API so every screen can be designed and
// exercised end-to-end before the backend is wired up.

export const ORDER_STATUS = {
  RECEIVED: 'RECEIVED',
  CONFIRMED: 'CONFIRMED',
  PACKED: 'PACKED',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  DELIVERED: 'DELIVERED',
  FAILED: 'FAILED',
};

export const ORDER_COLUMNS = [
  { key: ORDER_STATUS.RECEIVED, title: 'Received', hint: 'New orders to confirm' },
  { key: ORDER_STATUS.CONFIRMED, title: 'Confirmed', hint: 'Ready to pack' },
  { key: ORDER_STATUS.PACKED, title: 'Packed', hint: 'Ready for a rider' },
  { key: ORDER_STATUS.OUT_FOR_DELIVERY, title: 'Out for delivery', hint: 'On the road' },
  { key: ORDER_STATUS.DELIVERED, title: 'Delivered', hint: 'Completed today' },
  { key: ORDER_STATUS.FAILED, title: 'Failed', hint: 'Needs attention' },
];

const names = [
  'Ananya Rao', 'Vikram Sharma', 'Priya Nair', 'Arjun Reddy', 'Sneha Kulkarni',
  'Rohit Verma', 'Divya Iyer', 'Karthik Menon', 'Meera Pillai', 'Sanjay Gupta',
  'Lakshmi Narayan', 'Farhan Ali', 'Pooja Desai', 'Aditya Singh', 'Nisha Bhat',
];

const streets = [
  'Jubilee Hills, Rd No. 12', 'Banjara Hills, Rd No. 3', 'Gachibowli Main Rd',
  'Kondapur, Botanical Garden Rd', 'Madhapur, Hitech City', 'Ameerpet Metro Rd',
  'Kukatpally Housing Board', 'Begumpet Alsa Mall Rd',
];

const products = [
  { id: 'P-1001', name: 'Sona Masoori Rice 5kg', sku: 'GR-RICE-5', barcode: '8901030875213', category: 'Staples', price: 349, mrp: 399, unit: 'bag', stock: 42, lowStockThreshold: 15, swatch: '#F2B922', emoji: '🌾', status: 'ACTIVE', gstRate: 5, hsnCode: '1006' },
  { id: 'P-1002', name: 'Toor Dal 1kg', sku: 'GR-DAL-1', barcode: '8901030875220', category: 'Staples', price: 165, mrp: 180, unit: 'pack', stock: 8, lowStockThreshold: 12, swatch: '#D9A30F', emoji: '🫘', status: 'ACTIVE', gstRate: 5, hsnCode: '0713' },
  { id: 'P-1003', name: 'Groundnut Oil 1L', sku: 'GR-OIL-1', barcode: '8901030875237', category: 'Cooking Essentials', price: 210, mrp: 230, unit: 'bottle', stock: 26, lowStockThreshold: 10, swatch: '#2E7D32', emoji: '🫗', status: 'ACTIVE', gstRate: 5, hsnCode: '1508' },
  { id: 'P-1004', name: 'Amul Toned Milk 1L', sku: 'DY-MILK-1', barcode: '8901030875244', category: 'Dairy', price: 62, mrp: 62, unit: 'pouch', stock: 4, lowStockThreshold: 20, swatch: '#2F6FED', emoji: '🥛', status: 'ACTIVE', gstRate: 0, hsnCode: '0401' },
  { id: 'P-1005', name: 'Farm Fresh Eggs (12)', sku: 'DY-EGG-12', barcode: '8901030875251', category: 'Dairy', price: 84, mrp: 90, unit: 'tray', stock: 18, lowStockThreshold: 10, swatch: '#7C3AED', emoji: '🥚', status: 'ACTIVE', gstRate: 0, hsnCode: '0407' },
  { id: 'P-1006', name: 'Alphonso Mango 1kg', sku: 'FV-MNG-1', barcode: '8901030875268', category: 'Fruits & Veg', price: 220, mrp: 260, unit: 'kg', soldBy: 'EACH', stock: 0, lowStockThreshold: 8, swatch: '#0D9488', emoji: '🥭', status: 'ACTIVE', gstRate: 0, hsnCode: '0804' },
  { id: 'P-1007', name: 'Onion 1kg', sku: 'FV-ONI-1', barcode: '8901030875275', category: 'Fruits & Veg', price: 38, mrp: 42, unit: 'kg', soldBy: 'EACH', stock: 63, lowStockThreshold: 20, swatch: '#B8850A', emoji: '🧅', status: 'ACTIVE', gstRate: 0, hsnCode: '0703' },
  { id: 'P-1011', name: 'Tomato loose', sku: 'TOM-LOOSE', barcode: '', category: 'Fruits & Veg', price: 40, mrp: 45, unit: 'kg', soldBy: 'WEIGHT', stock: 25.5, lowStockThreshold: 8, minOrderQty: 0.25, maxOrderQty: 10, qtyStep: 0.05, swatch: '#E11D48', emoji: '🍅', status: 'ACTIVE', gstRate: 0, hsnCode: '070200' },
  { id: 'P-1008', name: 'MTR Rava Idli Mix', sku: 'RE-RTE-3', barcode: '8901030875282', category: 'Ready to Eat', price: 95, mrp: 105, unit: 'pack', stock: 31, lowStockThreshold: 10, swatch: '#D32F2F', emoji: '🍚', status: 'ACTIVE', gstRate: 18, hsnCode: '2106' },
  { id: 'P-1009', name: 'Britannia Marie Gold', sku: 'SN-BIS-2', barcode: '8901030875299', category: 'Snacks', price: 35, mrp: 35, unit: 'pack', stock: 9, lowStockThreshold: 15, swatch: '#F2B922', emoji: '🍪', status: 'DRAFT', gstRate: 18, hsnCode: '1905' },
  { id: 'P-1010', name: 'Tata Salt 1kg', sku: 'GR-SLT-1', barcode: '8901030875305', category: 'Staples', price: 25, mrp: 28, unit: 'pack', stock: 50, lowStockThreshold: 15, swatch: '#2E7D32', emoji: '🧂', status: 'ACTIVE', gstRate: 0, hsnCode: '2501' },
];

export const categories = [
  { id: 'CAT-01', name: 'Staples', emoji: '🌾', color: '#F2B922', status: 'ACTIVE', defaultGstRate: 5 },
  { id: 'CAT-02', name: 'Cooking Essentials', emoji: '🫗', color: '#2E7D32', status: 'ACTIVE', defaultGstRate: 5 },
  { id: 'CAT-03', name: 'Dairy', emoji: '🥛', color: '#2F6FED', status: 'ACTIVE', defaultGstRate: 0 },
  { id: 'CAT-04', name: 'Fruits & Veg', emoji: '🥭', color: '#0D9488', status: 'ACTIVE', defaultGstRate: 0 },
  { id: 'CAT-05', name: 'Ready to Eat', emoji: '🍚', color: '#D32F2F', status: 'ACTIVE', defaultGstRate: 18 },
  { id: 'CAT-06', name: 'Snacks', emoji: '🍪', color: '#7C3AED', status: 'ACTIVE', defaultGstRate: 18 },
];

const riders = [
  { id: 'R-01', name: 'Suresh Yadav', phone: '+91 98450 11223', status: 'available' },
  { id: 'R-02', name: 'Naveen Kumar', phone: '+91 98450 33445', status: 'available' },
  { id: 'R-03', name: 'Imran Sheikh', phone: '+91 98450 55667', status: 'busy' },
  { id: 'R-04', name: 'Ramesh Babu', phone: '+91 98450 77889', status: 'available' },
];

function pick(arr, seed) {
  return arr[seed % arr.length];
}

function buildItems(seed) {
  const count = (seed % 3) + 1;
  const items = [];
  for (let i = 0; i < count; i += 1) {
    const p = products[(seed + i * 3) % products.length];
    const qty = ((seed + i) % 3) + 1;
    items.push({ productId: p.id, name: p.name, price: p.price, qty, emoji: p.emoji });
  }
  return items;
}

function money(items) {
  return items.reduce((sum, it) => sum + it.price * it.qty, 0);
}

const statusPlan = [
  ORDER_STATUS.RECEIVED, ORDER_STATUS.RECEIVED, ORDER_STATUS.RECEIVED,
  ORDER_STATUS.CONFIRMED, ORDER_STATUS.CONFIRMED, ORDER_STATUS.CONFIRMED,
  ORDER_STATUS.PACKED, ORDER_STATUS.PACKED,
  ORDER_STATUS.OUT_FOR_DELIVERY, ORDER_STATUS.OUT_FOR_DELIVERY,
  ORDER_STATUS.DELIVERED, ORDER_STATUS.DELIVERED, ORDER_STATUS.DELIVERED,
  ORDER_STATUS.FAILED,
];

export const orders = statusPlan.map((status, idx) => {
  const items = buildItems(idx + 1);
  const subtotal = money(items);
  const deliveryFee = subtotal >= 499 ? 0 : 29;
  const placedMinutesAgo = 6 + idx * 17;
  const assignedRider = status === ORDER_STATUS.OUT_FOR_DELIVERY || status === ORDER_STATUS.DELIVERED
    ? pick(riders, idx)
    : null;
  return {
    id: `BH-2409${(100 + idx)}`,
    status,
    customer: {
      name: pick(names, idx),
      phone: `+91 90${String(10000000 + idx * 7919).slice(0, 8)}`,
    },
    address: `${pick(streets, idx)}, Hyderabad`,
    items,
    subtotal,
    deliveryFee,
    total: subtotal + deliveryFee,
    paymentMethod: idx % 3 === 0 ? 'UPI' : idx % 3 === 1 ? 'Card' : 'Cash on Delivery',
    placedAt: new Date(Date.now() - placedMinutesAgo * 60000).toISOString(),
    rider: assignedRider,
    notes: idx % 4 === 0 ? 'Leave at the door, ring twice.' : '',
    failureReason: status === ORDER_STATUS.FAILED ? 'Customer unreachable at delivery address' : null,
  };
});

export const availableRiders = riders;

export { products };

export const stockMovements = [
  { id: 'M-501', productId: 'P-1002', productName: 'Toor Dal 1kg', type: 'OUT', qty: 24, reason: 'Order fulfilment', user: 'Kavya (Packer)', date: '2026-08-04T08:12:00' },
  { id: 'M-502', productId: 'P-1004', productName: 'Amul Toned Milk 1L', type: 'IN', qty: 60, reason: 'Vendor delivery — Amul Dairy', user: 'Ravi (Stock)', date: '2026-08-04T06:40:00' },
  { id: 'M-503', productId: 'P-1006', productName: 'Alphonso Mango 1kg', type: 'ADJUST', qty: -6, reason: 'Spoilage write-off', user: 'Ravi (Stock)', date: '2026-08-03T19:05:00' },
  { id: 'M-504', productId: 'P-1009', productName: 'Britannia Marie Gold', type: 'IN', qty: 40, reason: 'Vendor delivery — Britannia', user: 'Kavya (Packer)', date: '2026-08-03T11:20:00' },
  { id: 'M-505', productId: 'P-1001', productName: 'Sona Masoori Rice 5kg', type: 'OUT', qty: 10, reason: 'Order fulfilment', user: 'System', date: '2026-08-03T09:55:00' },
  { id: 'M-506', productId: 'P-1007', productName: 'Onion 1kg', type: 'ADJUST', qty: 12, reason: 'Recount correction', user: 'Ravi (Stock)', date: '2026-08-02T17:30:00' },
];

export const events = [
  {
    id: 'EVT-01',
    name: 'Independence Day Specials',
    description: 'Flag-themed grocery deals through 15 August.',
    status: 'ACTIVE',
    pricingMode: 'PERCENT',
    discountPercent: 10,
    couponCode: '',
    startsAt: '2026-08-12T00:00:00+05:30',
    endsAt: '2026-08-16T23:59:59+05:30',
    imageUrl: '',
    itemIds: ['P-1001', 'P-1003', 'P-1008', 'P-1010'],
  },
  {
    id: 'EVT-02',
    name: 'Onam Sadhya Essentials',
    description: 'Rice, dal, produce and dairy for a traditional feast.',
    status: 'ACTIVE',
    pricingMode: 'NONE',
    discountPercent: '',
    couponCode: '',
    startsAt: '2026-08-20T00:00:00+05:30',
    endsAt: '2026-08-28T23:59:59+05:30',
    imageUrl: '',
    itemIds: ['P-1001', 'P-1002', 'P-1004', 'P-1007'],
  },
  {
    id: 'EVT-03',
    name: 'Diwali Gift Hamper',
    description: 'Sweets, snacks and staples for the festival of lights.',
    status: 'ACTIVE',
    pricingMode: 'COUPON',
    discountPercent: '',
    couponCode: 'FEST20',
    startsAt: '2026-10-20T00:00:00+05:30',
    endsAt: '2026-11-02T23:59:59+05:30',
    imageUrl: '',
    itemIds: ['P-1008', 'P-1009', 'P-1005'],
  },
  {
    id: 'EVT-04',
    name: 'Summer Coolers',
    description: 'Seasonal collection — now closed.',
    status: 'INACTIVE',
    pricingMode: 'PERCENT',
    discountPercent: 15,
    couponCode: '',
    startsAt: '2026-04-01T00:00:00+05:30',
    endsAt: '2026-06-30T23:59:59+05:30',
    imageUrl: '',
    itemIds: ['P-1006'],
  },
];

export const coupons = [
  { id: 'C-01', code: 'WELCOME50', type: 'FLAT', value: 50, minOrder: 299, usageLimit: 500, used: 214, status: 'ACTIVE', expiresAt: '2026-09-30' },
  { id: 'C-02', code: 'FEST20', type: 'PERCENT', value: 20, minOrder: 599, usageLimit: 1000, used: 866, status: 'ACTIVE', expiresAt: '2026-08-15' },
  { id: 'C-03', code: 'FREESHIP', type: 'FLAT', value: 29, minOrder: 199, usageLimit: 2000, used: 1980, status: 'ACTIVE', expiresAt: '2026-12-31' },
  { id: 'C-04', code: 'SUMMER10', type: 'PERCENT', value: 10, minOrder: 0, usageLimit: 300, used: 300, status: 'EXPIRED', expiresAt: '2026-06-30' },
  { id: 'C-05', code: 'VIP100', type: 'FLAT', value: 100, minOrder: 999, usageLimit: 150, used: 42, status: 'PAUSED', expiresAt: '2026-10-01' },
];

export const staff = [
  { id: 'U-01', name: 'Vamshi Reddy', email: 'vamshi@bhimastore.in', role: 'Admin', group: 'store-admins', status: 'ACTIVE', lastActive: '2026-08-04T09:02:00' },
  { id: 'U-02', name: 'Kavya Reddy', email: 'kavya@bhimastore.in', role: 'Staff', group: 'store-staff', status: 'ACTIVE', lastActive: '2026-08-04T08:55:00' },
  { id: 'U-03', name: 'Ravi Teja', email: 'ravi@bhimastore.in', role: 'Staff', group: 'store-staff', status: 'ACTIVE', lastActive: '2026-08-04T07:40:00' },
  { id: 'U-04', name: 'Shalini Rao', email: 'shalini@bhimastore.in', role: 'Staff', group: 'store-staff', status: 'ACTIVE', lastActive: '2026-08-03T21:10:00' },
  { id: 'U-05', name: 'Deepak Nair', email: 'deepak@bhimastore.in', role: 'Staff', group: 'store-staff', status: 'INVITED', lastActive: null },
  { id: 'U-06', name: 'Suresh Yadav', email: 'suresh@bhimastore.in', role: 'Delivery Partner', group: 'delivery-partners', status: 'ACTIVE', lastActive: '2026-08-04T09:10:00' },
  { id: 'U-07', name: 'Naveen Kumar', email: 'naveen@bhimastore.in', role: 'Delivery Partner', group: 'delivery-partners', status: 'ACTIVE', lastActive: '2026-08-04T08:30:00' },
];

export const feeConfig = {
  baseFee: 29,
  freeDeliveryThreshold: 499,
  perKmFee: 6,
  maxDeliveryRadiusKm: 8,
};

export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const weekday = { open: true, opensAt: '09:00', closesAt: '22:00' };
const weekend = { open: true, opensAt: '10:00', closesAt: '21:00' };

export const storeHours = {
  Mon: { ...weekday },
  Tue: { ...weekday },
  Wed: { ...weekday },
  Thu: { ...weekday },
  Fri: { ...weekday },
  Sat: { ...weekend },
  Sun: { ...weekend },
};

export function formatCurrency(amount) {
  return `₹${amount.toLocaleString('en-IN')}`;
}

export function timeAgo(iso) {
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}
